<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('sistemaconcorrente')">Concorrentes</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ title }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-10 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.descricao" placeholder="google..." :error="form.errors.descricao" class="pr-6  w-full" maxlength="100" label="Descricão" />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center space-x-2">
          <button v-if="editMode" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Apagar</button>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit"> {{ submitTextButton }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
const BASE_URL = 'sistemaconcorrente'
export default {
  name: 'CreateOrEdit',
  metaInfo() {
    return { title: this.title }
  },
  components: {
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    model: {
      type: Object,
      default() {
        return {}
      },
    },

  },
  data() {
    return {
      show: false,
      imgDataUrl: '',
      form: this.$inertia.form({
        idEmpresaAtividade: null,
        descricao: null,
      }),
    }
  },
  computed: {
    title() {
      return this.editMode ? 'Editar' : 'Criar'
    },
    editMode() {
      return this.model.idEmpresaAtividade ? true : false
    },
    submitTextButton() {
      return this.editMode ? 'Atualizar' : 'Criar'
    },

  },
  created(){
    if(this.editMode){
      this.form = {...this.form, ...this.model}
    }
  },
  remember: 'form',
  methods: {
    submit(){
      if(this.editMode){
        this.update()
      }else{
        this.store()
      }
    },
    store() {
      this.form.post(this.route(BASE_URL+'.store'))
    },
    update() {
      this.form.put(this.route(BASE_URL+'.update', this.model.idEmpresaAtividade))
    },
    destroy() {
      if (confirm('Você deseja mesmo apagar esse registro?')) {
        this.$inertia.delete(this.route(BASE_URL+'.destroy', this.model.idEmpresaAtividade))
      }
    },

  },
}
</script>
